export const EscrowManagementData = [
  {
    id: 0,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/EfficientFundManagement.png",
    title: "Efficient Fund Management",
    description:
      "Open multiple escrows, define routing weightage & automate fund splitting & transfers",
  },
  {
    id: 1,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/QuickTurnaroundTime.png",
    title: "Quick Turnaround Time",
    description:
      "Speed up your launch with our digital escrows, ensuring swift, timely transactions",
  },
  {
    id: 2,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/PowerfulRiskEngine.png",
    title: "Powerful Risk Engine",
    description:
      "Multi-level approval workflow guarantees bulletproof security with every step rigorously validated",
  },
  {
    id: 3,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/SEBIApprovedTrustee.png",
    title: "SEBI Approved Trustee",
    description:
      "Secure transactions with our SEBI-backed trustee service, protecting all involved parties",
  },
  {
    id: 4,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/AutomatedReconciliation.png",
    title: "Automated Reconciliation",
    description:
      "Achieve near 100% effortless automated reconciliation in under 5 minutes",
  },
  {
    id: 5,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Industry’s-bestTAT&SuccessRate.png",
    title: "Industry’s-best TAT & Success Rate",
    description:
      "Achieve 99.95% payout success rate with our multi-bank routing",
  },
  {
    id: 6,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/RobustAPIs.png",
    title: "Robust APIs",
    description:
      "Ensure seamless integration, supporting 20M daily API requests with 99.99% uptime.",
  },
  {
    id: 7,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/OneStopSolution.png",
    title: "One Stop Solution",
    description:
      "Manage pay-ins and payouts, control multiple accounts with a unified, advanced dashboard",
  },
];
export const club100 = [
  {
    id: 0,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/SecurePayments.png",
    title: "100%",
    description: "Secure Payments",
  },
  {
    id: 1,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/ProtectedandCompliant.png",
    title: "100%",
    description: "Protected and Compliant",
  },
  {
    id: 2,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/SafeDigitalControl.png",
    title: "100%",
    description: "Safe Digital Control",
  },
  {
    id: 3,
    img:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/ReliableatScale.png",
    title: "100%",
    description: "Reliable at Scale",
  },
];

export const col1 = [
  {
    id: 0,
    background: "#FEEEC166",
    text: "Online Marketplaces",
  },
  {
    id: 1,
    background: "#E3D2FF66",
    text: "Supply Chain Financing",
  },
  {
    id: 2,
    background: "#F6F6FE",
    text: "Merger & Acquisition",
  },
  {
    id: 3,
    background: "#E3D2FF66",
    text: "Vendor Payment Platforms",
  },
  {
    id: 4,
    background: "#BDEFD966",
    text: "Brand/Campaign Payments",
  },
  {
    id: 5,
    background: "#FEEEC166",
    text: "Credit Card Bill Payments",
  },
];
export const col2 = [
  {
    id: 0,
    background: "#F6F6FE",
    text: "E-commerce/ D2C",
  },
  {
    id: 1,
    background: "#BDEFD966",
    text: "Invoice Discounting",
  },
  {
    id: 2,
    background: "#E3D2FF66",
    text: "P2P Lending",
  },
  {
    id: 3,
    background: "#FEEEC166",
    text: "Fractional Investments",
  },
  {
    id: 4,
    background: "#F4F5FF",
    text: "Expense Management",
  },
  {
    id: 5,
    background: "#FFE1F066",
    text: "Startup Investments & NCD",
  },
];
export const col3 = [
  {
    id: 0,
    background: "#FFE1F066",
    text: "Payouts",
  },
  {
    id: 1,
    background: "#FEEEC166",
    text: "Subscription Payments",
  },
  {
    id: 2,
    background: "#F6F6FE",
    text: "Buy-Sell/Rental",
  },
  {
    id: 3,
    background: "#BDEFD966",
    text: "Alternative Investments",
  },
  {
    id: 4,
    background: "#FFE1F066",
    text: "Payroll Platforms",
  },
  {
    id: 5,
    background: "#F6F6FE",
    text: "VC & Angel Investment",
  },
];
export const col4 = [
  {
    id: 0,
    background: "#F6F6FE",
    text: "Revenue Based Financing",
  },
  {
    id: 1,
    background: "#BDEFD966",
    text: "Co-lending",
  },
  {
    id: 2,
    background: "#E3D2FF66",
    text: "Save Now Pay Later [SNPL]",
  },
  {
    id: 3,
    background: "#FEEEC166",
    text: "Security Deposit",
  },
  {
    id: 4,
    background: "#F4F5FF",
    text: "Milestone-based Payments",
  },
  {
    id: 5,
    background: "#FFE1F066",
    text: "Crowd Sourcing",
  },
];

export const allLogoData = [
  {
    id: 0,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Apollo.png",
    alt: "Tata Cliq",
    width: "130",
    height: "48",
  },
  {
    id: 1,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Branch.png",
    alt: "cred",
    width: "130",
    height: "48",
  },
  {
    id: 2,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Cred.png",
    alt: "APML",
    width: "130",
    height: "48",
  },
  {
    id: 3,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/DMI_Finance.png",
    alt: "The Nestery",
    width: "130",
    height: "48",
  },
  {
    id: 4,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Furlenco.png",
    alt: "bombay-shirt-company",
    width: "130",
    height: "48",
  },
  {
    id: 5,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Khatabook.png",
    alt: "khadi essentials",
    width: "130",
    height: "48",
  },
  {
    id: 6,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Liquiloans.png",
    alt: "wed me good",
    width: "130",
    height: "48",
  },
  {
    id: 7,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Meesho.png",
    alt: "wonderchef",
    width: "130",
    height: "48",
  },
  {
    id: 8,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/PocketlyLogo.png",
    alt: "pinelabs",
    width: "130",
    height: "48",
  },
  {
    id: 9,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Refyne.png",
    alt: "bajaj-finserv",
    width: "130",
    height: "48",
  },
  {
    id: 10,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/Ring.png",
    alt: "drivezy",
    width: "130",
    height: "48",
  },
  {
    id: 11,
    src:
      "https://cashfreelogo.cashfree.com/website/landings/escrow-account/UNI.png",
    alt: "raw",
    width: "130",
    height: "48",
  },
];
